import React from "react";
import { useDocumentTitle } from "@storyteller/components/src/hooks/UseDocumentTitle";
import { PosthogClient } from "@storyteller/components/src/analytics/PosthogClient";
import { Container } from "components/common";
import FakeYouLandingHeader from "./fakeyou/FakeYouLandingHeader";
import Dashboard from "./Dashboard";
import "./LandingPage.scss";
import {
  Website,
  GetWebsite,
} from "@storyteller/components/src/env/GetWebsite";
import PostlaunchLanding from "./storyteller/PostlaunchLanding/PostlaunchLanding";
import ArtcraftLanding from "./artcraft/ArtcraftLanding";
import MentionsSection from "components/common/MentionsSection";
import { useSession } from "hooks";
import { useFeatureFlags } from "hooks/useFeatureFlags";

interface LandingPageProps {
  // When true, render the original ("legacy") Storyteller landing instead of
  // the new ArtCraft promo. Used by the /legacy route.
  legacy?: boolean;
}

export default function LandingPage({ legacy = false }: LandingPageProps) {
  PosthogClient.recordPageview();

  const { sessionWrapper } = useSession();

  const domain = GetWebsite();

  // The new ArtCraft landing uses an exact title (no "| Storyteller.ai" suffix)
  // since we're rebranding. FakeYou/legacy keep their prefixed titles.
  const webpageTitle =
    domain.website === Website.FakeYou
      ? "FakeYou Celebrity Voice Generator | FakeYou"
      : legacy
        ? "AI Creation Engine | Storyteller.ai"
        : "We're Now ArtCraft";

  useDocumentTitle(webpageTitle);

  const isLoggedIn = sessionWrapper.isLoggedIn();

  const { isVideoToolsEnabled } = useFeatureFlags();

  return (
    <>
      {domain.website === Website.StorytellerAi &&
        (legacy ? <PostlaunchLanding /> : <ArtcraftLanding />)}
      {domain.website === Website.FakeYou && (
        <>
          <Container type="panel">
            {!isVideoToolsEnabled() && !sessionWrapper.isLoggedIn() && (
              <FakeYouLandingHeader />
            )}

            <Dashboard />
          </Container>
          {!isLoggedIn && (
            <Container type="panel">
              <MentionsSection />
            </Container>
          )}
        </>
      )}
    </>
  );
}
